// import { DetailInnovation } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormEntrepreneurContainer";
import { DetailInnovationCourseContainer } from "../../../containers/SupportSystem/SupportForm/DetailInnovationCourseContainer";
export function DetailInnovationCoursePage() {
    return (
        <DetailInnovationCourseContainer/>
    );

}